// CANONICAL COPY (GH #7115). src/constants/obligations/obl-web-filtering.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-web-filtering',
  title: 'Verify web filtering controls',
  description:
    'Confirm that access to external websites is managed to reduce exposure to malicious content. Web filtering controls (DNS filtering, URL allow/deny-lists, proxy or secure web gateway) shall be implemented, maintained and reviewed. Document exceptions and compensating controls.',
  category: 'technical',
  scfIds: ['SCF-NET-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Web filtering policy or standard is published' },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
